import { render } from "./FractionalCdSlider.vue?vue&type=template&id=2b8ba3ed&scoped=true&ts=true"
import script from "./FractionalCdSlider.vue?vue&type=script&lang=ts"
export * from "./FractionalCdSlider.vue?vue&type=script&lang=ts"

import "./FractionalCdSlider.vue?vue&type=style&index=0&id=2b8ba3ed&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8ba3ed"]])

export default __exports__